// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2024 (original work) Open Assessment Technologies SA
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License

import config from '@/config';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';

export const routing = [
    {
        path: [config.routes.systemSettings.systemSettings],
        controller: () => import('../systemSettings/controllers/systemSettings'),
        guard: getPermissionsGuard([{ resource: 'portal.system-settings', scopes: ['edit'] }])
    }
];
